import type { KpiCardSpec } from './card-spec';

/**
 * The Active users (MAU) scalar, shown on both the Acquisition Featured row
 * and the Engagement page's Key metrics section. One object in two catalogs,
 * so the two pages cannot report different figures for the same KPI.
 */
export const MAU_SCALAR_CARD: KpiCardSpec = {
    // The window's END follows the page Period filter, but its WIDTH is
    // always 30 days regardless of how long the selected period itself spans.
    title: 'Active users (MAU)',
    source: 'login-activity',
    form: 'number',
    metric: 'monthlyActiveUsers',
    size: 'sm',
    description:
        "Users who signed in at least once during the trailing 30 days ending on the selected period's end date, counted once each regardless of how many times they signed in during that window. A period-over-period delta compares that window against the prior 30 days.",
};
